import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  FlowToolsService,
  StriveSimulationResponse,
} from '@core/services/flow-tools/flow-tools.service';

/**
 * Ejecuta en el CMS la misma calculadora de crédito que dispara el WhatsApp
 * Flow STRIVE_CO_TOKEN (ver chatbot_v1/flows/FlowStrive.js) — sin pasar por
 * WhatsApp, llamando directo a POST /chatBot/flowstrive.
 */
@Component({
  selector: 'app-strive-tester',
  templateUrl: './strive-tester.component.html',
  styleUrls: ['./strive-tester.component.scss'],
})
export class StriveTesterComponent {
  form: FormGroup;
  isLoading = false;
  errorMessage = '';
  result: StriveSimulationResponse['amortizacion'] | null = null;

  constructor(
    private fb: FormBuilder,
    private flowToolsService: FlowToolsService,
  ) {
    this.form = this.fb.group({
      loan_amount: ['', Validators.required],
      annual_rate: [''],
      monthly_rate: [''],
      loan_term: [''],
      loan_payment: [''],
      capital_payment_amount: [''],
      capital_payment_month: [''],
      second_payment_amount: [''],
      additional_payment_month: [''],
      third_payment_amount: [''],
      third_capital_payment_month: [''],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.errorMessage = 'El monto del préstamo es obligatorio.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.result = null;

    // Solo enviar campos con valor: el backend distingue "no vino el dato" de "vino vacío".
    const raw = this.form.value;
    const payload: Record<string, any> = {};
    Object.keys(raw).forEach((key) => {
      if (raw[key] !== '' && raw[key] !== null) {
        payload[key] = raw[key];
      }
    });

    this.flowToolsService.simulateStrive(payload as any).subscribe(
      (response) => {
        this.isLoading = false;
        if (response.ok) {
          this.result = response.amortizacion || null;
        } else {
          this.errorMessage = response.msg;
        }
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = `Error: ${error.error?.msg || error.message}`;
      },
    );
  }

  reset(): void {
    this.form.reset();
    this.result = null;
    this.errorMessage = '';
  }

  /** abonosCapital llega como objeto {"<mes>": "texto"}, no como array — no sirve un *ngFor directo. */
  get abonosList(): string[] {
    return Object.values(this.result?.abonosCapital || {});
  }
}
